import Vue from 'vue';
import { setup } from 'feedback-company-vue-components';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

const config = {
    language: 'en',
    labelEndpoint: `${process.env.VUE_APP_API_BASE_URL}/form/labels/${window.location.pathname.split('/')[1]}`,
};

setup({ config });

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');

// API's that need loading before user can use app
if (router.currentRoute.params.shop) {
    store.dispatch('getShop');
    store.dispatch('getPages');
} else {
    store.commit('setLoadingState', {
        stateKey: 'formPages',
        status: false,
    });
    store.commit('setLoadingState', {
        stateKey: 'shopSettings',
        status: false,
    });
    store.commit('setError', {
        code: '404',
        message: 'No shop defined in URL',
    });
}
